<div id="mail" class="page-layout carded left-sidenav simple-scroll">


  <mat-sidenav-container>

    <!-- SIDENAV -->
    <mat-sidenav class="sidenav mat-sidenav-opened" position="start" mode="side" opened="true"
                 fuseMatSidenavHelper="carded-left-sidenav" mat-is-locked-open="gt-md">
      <inbox-sidenav></inbox-sidenav>
    </mat-sidenav>
    <!-- / SIDENAV -->

    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT HEADER -->
      <!-- / CONTENT HEADER -->

      <!-- CONTENT CARD -->

      <div class="content-card mat-white-bg">

        <!-- CONTENT TOOLBAR -->
        <!--        <div class="toolbar" >&lt;!&ndash;fxHide.gt-md&ndash;&gt;-->
        <!--          <button mat-icon-button class="sidenav-toggle"-->
        <!--                  fuseMatSidenavToggler="carded-left-sidenav"-->
        <!--                  fxHide.gt-md aria-label="Toggle Sidenav">-->
        <!--            <mat-icon>menu</mat-icon>-->
        <!--          </button>-->
        <!--        </div>-->
        <!-- / CONTENT TOOLBAR -->

        <!--        <div fxLayout="row">-->
        <!--          <div>-->
        <!--              <app-mailbox-list></app-mailbox-list>-->
        <!--          </div>-->
        <!--          &lt;!&ndash; CONTENT &ndash;&gt;-->
        <!--          <div fxLayout="column" fxLayoutAlign="start start">-->
        <!--              <particle-mail-thread></particle-mail-thread>-->
        <!--          </div>-->
        <!--          &lt;!&ndash;         CONTENT &ndash;&gt;-->
        <!--        </div>-->
        <div class="inbox-container flex flex-row">
          <!--          <div style="width: 300px;">-->
          <!--            <app-mat-custom-datepicker [date]="current_date" (onDateUpdate)="updatedDate($event)"></app-mat-custom-datepicker>-->
          <!--          </div>-->

          <div class="content pos-relative">
            <div class="keno-grid-container">
              <particle-virtual-grid class="content-card mat-white-bg" [sourceKey]="sourceKey"
                                     sortFieldKey="LastModifiedDate"
                                     sortDirection="desc"
                                     version="v2"
                                     [serviceName]="serviceName"
                                     [api]="api"
                                     [invalidateSubject]="invalidateSubject"
                                     (valueChanged)="onGridCellValueChange($event)"
                                     [rowClass]="rowCallback"
                                     [parameters]="this.selectedTab.tabData"
              >
              </particle-virtual-grid>
            </div>
          </div>
          <div class="content pos-relative m-tb-30 hide">
            <particle-mail-thread></particle-mail-thread>
          </div>
          <!--         CONTENT -->
        </div>

      </div>
    </div>
    <!-- / CENTER -->
  </mat-sidenav-container>

  <button mat-fab color="warn" class="compose-btn " (click)="composeDialog()"><i class="far fa-plus"></i></button>

</div>
